import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AssociationLabelDto } from '@shared/models/association-label-dto';
import { Observable } from 'rxjs';

import { Association, AssociationLabel } from '@shared/models';

import { ApiParams, SortDir } from './api.service';
import { JobService } from './job.service';

export interface AssociationParams extends ApiParams {
  assigned: boolean;
  'sort.by'?: string;
  'sort.direction'?: SortDir;
}

@Injectable()
export class AssociationService extends JobService {
  constructor(http: HttpClient) {
    super(http);
    this.url = 'associations/';
  }

  getLabelForMany(
    associations: { reqId: number; candidateId: number }[],
  ): Observable<AssociationLabelDto[]> {
    return this.post({
      url: 'label/many',
      body: associations,
    });
  }

  postAssociateMany(associations: Partial<Association>[]): Observable<Association[]> {
    return this.post({ url: `many`, body: associations });
  }
}
